import React from 'react';

// TODO Add equivalent icon to DS and use here
import PlayIcon from 'mdi-react/YoutubePlayIcon';

import { Thumbnail, PlayIconWrapper } from './styles';

export const VideoThumbnail: React.FC<IVideoThumbnail> = props => (
  <Thumbnail className="pj-ui-carousel-video-thumbnail">
    <PlayIconWrapper className="pj-ui-carousel-video-thumbnail--play-icon">
      <PlayIcon />
    </PlayIconWrapper>
    <img src={props.src} alt="" />
  </Thumbnail>
);

interface IVideoThumbnail {
  src: string;
}
